export default {
  ended: {
    en: 'Ended',
  },
}
